import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, Map, fromJS } from 'immutable';
import { PieChart, Pie, LabelList, Cell, Sector, Tooltip as ChartTooltip } from 'recharts';
import { injectIntl, defineMessages } from 'react-intl';

import * as commonVar from 'libs/commonVar';

import { Image, Icon, Progress, Popup } from 'semantic-ui-react';
import { Tooltip, IconButton } from 'material-ui';
import {
  DetailTemplate,
  Button,
  MaterialSnackbar,
  Loading,
  LeakCountInfo,
  TagItem,
  ExamStep,
  InfectionPC
} from 'components';

import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';

import styles from './ExamDetail.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamDetailTag extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const {
      detailType,
      // 훈련 유형
      attachExamType,
      selectedDetailData,
      // 대상자 리스트
      targetListByTag,
      // 감염 대상
      infectionTarget,
      // 감염 PC
      infectionPC,
      // 대상자 리스트 로딩
      isLoadingTargetByTag,
      // 감염대상 로딩
      isLoadingTarget,
      // 감염 PC 로딩
      isLoadingPC,
      isSnackbar,
      tagInfo
    } = this.props;
    // function
    const {
      onMoveScroll,
      onRefRegister,
      onToggleSnackbar,
      onToggleDetailView,
      // [감염 대상] 열기 닫기
      onToggleInfectionTarget,
      // 태그별 대상자 리스트
      onGetTargetListByTag,
      // 감염 대상 조회
      onGetInfectionFile,
      // 감염 PC 조회
      onGetInfectionPC
    } = this.props;

    // ---------------------------------- 훈련 정보 ----------------------------------
    let detailData = Map({
      examNo: 0,
      examName: '-',
      target: 0,
      send: 0,
      read: 0,
      download: 0,
      cure: 0,
      infection: 0,
      declare: 0,
      edu: 0,
      eduBefore: 0,
      eduPlay: 0,
      eduAfter: 0,
      leakAllcount: 0,
      leakAllsize: 0,
      leakFileCount: 0,
      leakFileSize: 0,
      leakCertCount: 0,
      leakCertSize: 0,
      leakEmailCount: 0,
      leakEmailSize: 0,
      tagNo: 0,
      tagName: '',
      linkAttach: 0,
      examType: 0,
      attachScreenType: 0
    });

    if (!!selectedDetailData) {
      detailData = selectedDetailData;
    }

    // 피싱 유도 템플릿
    const isPhishing = 4 === detailData.get('examType') ? true : false;

    const btDatas = [
      {
        id: 'move-info',
        iconName: 'list',
        content: defineMessages(formatMessage({ id: 'ExamDetailTag_1', defaultMessage: '태그별 훈련 결과' })),
        isView: true
      },
      {
        id: 'move-tagTargetList',
        iconName: 'id card outline',
        content: defineMessages(formatMessage({ id: 'ExamDetailTag_2', defaultMessage: '태그 대상자 목록' })),
        isView: true
      },
      {
        id: 'move-infectionFile',
        iconName: 'file text outline',
        content: defineMessages(formatMessage({ id: 'ExamDetailTag_3', defaultMessage: '감염 가능 파일' })),
        isView: isPhishing ? false : true
      },
      {
        id: 'move-target',
        iconName: 'user',
        content: defineMessages(formatMessage({ id: 'ExamDetailTag_4', defaultMessage: '감염 대상' })),
        isView: isPhishing ? false : true
      },
      {
        id: 'move-pc',
        iconName: 'desktop',
        content: defineMessages(formatMessage({ id: 'ExamDetailTag_5', defaultMessage: '감염 PC' })),
        isView: isPhishing ? false : true
      }
    ];

    // ---------------------------------- 태그 대상자 목록 ----------------------------------
    const TagTargetList = targetListByTag.get('data').map((tlData, index) => {
      // 피싱 유도 템플릿
      const isPhishing = 4 === tlData.get('examType') ? true : false;
      // 메일 발송 실패
      const sendFail = !!tlData.get('sendError');
      // 훈련 메일 나눔 발송 (랜덤 발송)
      const sendReserve = !!tlData.get('sendReserve') && !tlData.get('send');
      // 메일발송 일시 정지
      const sendStop = !!tlData.get('isSuspend') && !tlData.get('send');

      let stepText = defineMessages(formatMessage({ id: 'ExamDetailTag_9', defaultMessage: '준비' }));
      if (1 === tlData.get('examType') && 2 === attachExamType && !!tlData.get('cure')) {
        stepText = defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }));
      } else if (!!tlData.get('infection')) {
        stepText = isPhishing
          ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
          : defineMessages(formatMessage({ id: 'ExamDetailTag_6', defaultMessage: '감염' }));
      } else if (!!tlData.get('download')) {
        stepText = isPhishing
          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
          : defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' }));
      } else if (!!tlData.get('read')) {
        stepText = defineMessages(formatMessage({ id: 'ExamDetailTag_7', defaultMessage: '열람' }));
      } else if (sendFail) {
        stepText = defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' }));
      } else if (sendStop) {
        stepText = defineMessages(formatMessage({ id: 'ExamListItem_28', defaultMessage: '발송 정지' }));
      } else if (sendReserve) {
        stepText = defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' }));
      } else if (!!tlData.get('send')) {
        stepText = defineMessages(formatMessage({ id: 'ExamDetailTag_8', defaultMessage: '안전' }));
      }

      let sendTooltip = defineMessages(formatMessage({ id: 'ExamListItem_4', defaultMessage: '발송' }));
      if (sendFail) {
        sendTooltip = defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' }));
      } else if (!!sendStop) {
        sendTooltip = !!sendReserve
          ? '(' +
            defineMessages(formatMessage({ id: 'ExamListItem_27', defaultMessage: '발송 일시 정지' })) +
            ') ' +
            defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' })) +
            ': ' +
            common.timeFormatFromUTCEpoch(tlData.get('sendReserve'))
          : defineMessages(formatMessage({ id: 'ExamListItem_27', defaultMessage: '발송 일시 정지' }));
      } else if (!!sendReserve && !sendStop) {
        sendTooltip =
          defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' })) +
          ': ' +
          common.timeFormatFromUTCEpoch(tlData.get('sendReserve'));
      } else if (!!tlData.get('send')) {
        sendTooltip += ': ' + common.timeFormatFromUTCEpoch(tlData.get('send'));
      }
      const readTooltip =
        defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' })) +
        (tlData.get('read') ? ': ' + common.timeFormatFromUTCEpoch(tlData.get('read')) : '');
      const downTooltip =
        (isPhishing
          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
          : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))) +
        (tlData.get('download') ? ': ' + common.timeFormatFromUTCEpoch(tlData.get('download')) : '');
      const infectionTooltip =
        (isPhishing
          ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
          : defineMessages(formatMessage({ id: 'ExamListItem_6', defaultMessage: '감염' }))) +
        (tlData.get('infection') ? ': ' + common.timeFormatFromUTCEpoch(tlData.get('infection')) : '');
      const cureTooltip =
        defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' })) +
        (tlData.get('cure') ? ': ' + common.timeFormatFromUTCEpoch(tlData.get('cure')) : '');

      return (
        <div key={index} className={cx('tagTarget-list')}>
          <Popup
            trigger={
              <div className={cx('targetInfo ellipsis')}>
                {tlData.get('targetName') + '(' + tlData.get('targetEmail') + ')'}
              </div>
            }
            content={
              <div>
                <div>
                  {defineMessages(formatMessage({ id: 'ExamDetailTag_12', defaultMessage: '대상자 번호' })) +
                    ': ' +
                    tlData.get('targetNo')}
                </div>
                <div>
                  {defineMessages(formatMessage({ id: 'ExamDetailTag_13', defaultMessage: '대상자 이름' })) +
                    ': ' +
                    tlData.get('targetName')}
                </div>
                <div>
                  {defineMessages(formatMessage({ id: 'ExamDetailTag_14', defaultMessage: '대상자 이메일' })) +
                    ': ' +
                    tlData.get('targetEmail')}
                </div>
              </div>
            }
            size="mini"
          />
          <div className={cx('step-area')}>
            <div
              className={cx(
                'step-title',
                { 'color-orange': !!tlData.get('read') && !tlData.get('infection') && !tlData.get('download') },
                { 'color-down': !!tlData.get('download') && !tlData.get('infection') },
                { 'color-red': (!!tlData.get('infection') || !!tlData.get('sendError')) && !tlData.get('cure') },
                { 'color-cure': !!tlData.get('cure') }
              )}>
              {stepText}
            </div>
            {/* 대상 */}
            <ExamStep
              active
              title={defineMessages(formatMessage({ id: 'ExamListItem_3', defaultMessage: '대상' }))}
              stepType="target"
            />
            {/* 발송 */}
            <ExamStep
              active={!!tlData.get('send') || !!sendStop || !!sendReserve || !!sendFail}
              title={sendTooltip}
              stepType="send"
              sendStop={sendStop}
              sendReserve={sendReserve && !sendStop}
              sendFail={sendFail}
            />
            {/* 열람 */}
            <ExamStep
              active={!!tlData.get('read') || !!tlData.get('download') || !!tlData.get('infection')}
              title={readTooltip}
              stepType="read"
            />
            {/* 다운 */}
            {(2 & tlData.get('linkAttach') || isPhishing) && (
              <ExamStep
                active={!!tlData.get('download') || !!tlData.get('infection')}
                title={downTooltip}
                stepType={isPhishing ? 'access' : 'down'}
              />
            )}
            {/* 감염 */}
            <ExamStep
              active={!!tlData.get('infection')}
              title={infectionTooltip}
              stepType={isPhishing ? 'leak' : 'infection'}
            />
            {/* 치료 */}
            {1 === tlData.get('examType') &&
              2 === attachExamType && <ExamStep active={!!tlData.get('cure')} title={cureTooltip} stepType="cure" />}
          </div>
        </div>
      );
    });

    // ---------------------------------- 감염 가능 파일 ----------------------------------
    const infectionFileArray = [
      // 데이터가 없을때 표시
      {
        name: '',
        color: '',
        value: detailData.get('leakAllcount') > 0 ? 0 : 100,
        file: '',
        label: '',
        percent: detailData.get('leakAllcount') > 0 ? 0 : 100,
        percentLabel: ''
      },
      {
        name: 'pc',
        color: '#43cbaa',
        value: detailData.get('leakFileCount'),
        file: detailData.get('leakFileSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetailTag_15', defaultMessage: 'PC 파일' })),
        percent: (detailData.get('leakFileCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakFileCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      },
      {
        name: 'cert',
        color: '#7b3faf',
        value: detailData.get('leakCertCount'),
        file: detailData.get('leakCertSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetailTag_16', defaultMessage: '인증서' })),
        percent: (detailData.get('leakCertCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakCertCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      },
      {
        name: 'email',
        color: '#6697da',
        value: detailData.get('leakEmailCount'),
        file: detailData.get('leakEmailSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetailTag_17', defaultMessage: '이메일' })),
        percent: (detailData.get('leakEmailCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakEmailCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      }
    ];
    const InfectionFile = (
      <div className={cx('infectFile-area')}>
        <div className={cx('examInfo')}>
          <span className={cx('allCount')}>
            {defineMessages(formatMessage({ id: 'ExamDetailTag_19', defaultMessage: '총' })) +
              ' ' +
              detailData.get('leakAllcount') +
              defineMessages(formatMessage({ id: 'ExamDetailTag_18', defaultMessage: '개' }))}
          </span>
          <span className={cx('allSize')}>({common.fileSizeTrans(detailData.get('leakAllsize')).common})</span>
        </div>
        <div className={cx('infectFile-item')}>
          <div>
            <PieChart width={130} height={130}>
              <Pie
                dataKey="value"
                data={[
                  {
                    name: 'background',
                    value: 100
                  }
                ]}
                cx={60}
                cy={60}
                paddingAngle={0}
                innerRadius={20}
                outerRadius={55}>
                <Cell fill="#f7f7f7" />
              </Pie>
              <Pie
                dataKey="value"
                data={infectionFileArray}
                cx={60}
                cy={60}
                innerRadius={25}
                outerRadius={50}
                startAngle={450}
                endAngle={90}
                paddingAngle={-1}
                activeIndex={0}
                activeShape={e => {
                  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = e;
                  return (
                    <g>
                      {/* 그라데이션 효과 */}
                      {/* 파일 */}
                      <defs>
                        <linearGradient id="43cbaa" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#39cbd2" />
                          <stop offset="50%" stopColor="#77eadf" />
                          <stop offset="100%" stopColor="#28c3a4" />
                        </linearGradient>
                      </defs>
                      {/* 인증서 */}
                      <defs>
                        <linearGradient id="7b3faf" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#753eaa" />
                          <stop offset="50%" stopColor="#a33ede" />
                          <stop offset="100%" stopColor="#6e19cc" />
                        </linearGradient>
                      </defs>
                      {/* 이메일 */}
                      <defs>
                        <linearGradient id="6697da" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#619dd8" />
                          <stop offset="100%" stopColor="#6649d2" />
                        </linearGradient>
                      </defs>

                      {/* 차트의 기본 형태 영역 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        // fill={fill}
                        fill="rgb(230,230,230)"
                      />
                      {/* 차트의 확장 처리 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        innerRadius={outerRadius - 1}
                        outerRadius={outerRadius + 8}
                        // fill={fill}
                        fill="rgb(230,230,230)"
                      />
                    </g>
                  );
                }}>
                {/* cell 안에 퍼센트 표시 */}
                {infectionFileArray.map((entry, index) => <Cell key={index} fill={'url(' + entry.color + ')'} />)}
              </Pie>
              <Tooltip
                content={({ payload }) => {
                  return payload.map((entry, index) => {
                    if (entry.name === 'pc' || entry.name === 'cert' || entry.name === 'email') {
                      return (
                        <div className={cx('chart2-tooltip')} key={index}>
                          <div className={cx('name')}>{entry.payload.label}</div>
                          <div className={cx('value')}>
                            {entry.value +
                              defineMessages(formatMessage({ id: 'ExamHeader_2', defaultMessage: '개' })) +
                              ' (' +
                              entry.payload.file +
                              ')'}
                          </div>
                        </div>
                      );
                    }
                  });
                }}
              />
            </PieChart>
          </div>
          <div className={cx('examDetail-infectionFile')}>
            <span className={cx('examDetail-legend')}>
              {infectionFileArray.map(
                (entry, index) =>
                  !!entry.name && (
                    <div className={cx('examInfo')} key={index}>
                      <span className={cx('examInfo-title')}>
                        <Icon name="circle" style={{ color: entry.color }} />
                        {entry.label}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {entry.value}
                        {defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                        {' (' + common.fileSizeTrans(entry.file).common + ')'}
                      </span>
                    </div>
                  )
              )}
            </span>
          </div>
        </div>
      </div>
    );

    // ---------------------------------- 감염 대상 ----------------------------------
    let InfectionTargetComponent = (
      <div className={cx('brand')}>
        <Icon name="checkmark box" />
        {defineMessages(formatMessage({ id: 'ExamDetailTag_20', defaultMessage: '감염 대상 없음' }))}
      </div>
    );
    if (!isPhishing && infectionTarget.get('data') && infectionTarget.get('data').size > 0) {
      InfectionTargetComponent = infectionTarget.get('data').map((target, index) => (
        <div key={index} className={cx('infection-set')}>
          <div className={cx('infection-summary')}>
            <div className={cx('infection-title')}>
              <Tooltip
                title={target.get('targetName') + ' (' + target.get('targetEmail') + ')'}
                placement="bottom-start">
                <div className={cx('target-name ellipsis')}>
                  {target.get('targetName') + ' (' + target.get('targetEmail') + ')'}
                </div>
              </Tooltip>
              <IconButton
                color="primary"
                className={cx('bt-toggleView')}
                onClick={e => {
                  e.stopPropagation();
                  onToggleInfectionTarget(target.get('targetNo'));
                }}>
                <Image
                  src={
                    infectionTarget.get('isOpen').indexOf(target.get('targetNo')) !== -1
                      ? '/img/target/ico_close.png'
                      : '/img/target/ico_open.png'
                  }
                />
              </IconButton>
            </div>
            <div className={cx('infection-content')}>
              <div
                className={cx('target-info')}
                title={
                  (!!target.get('targetDivision') ? target.get('targetDivision') : '-') +
                  ' / ' +
                  (!!target.get('targetPosition') ? target.get('targetPosition') : '-')
                }>
                <div className={cx('targetDivision ellipsis')}>
                  {!!target.get('targetDivision') ? target.get('targetDivision') : '-'}
                </div>
                /
                <div className={cx('targetPosition ellipsis')}>
                  {!!target.get('targetPosition') ? target.get('targetPosition') : '-'}
                </div>
              </div>
              <div className={cx('pc-info-area')}>
                <InfectionPC
                  pcCount={target.get('infectionPc') ? target.get('infectionPc').size : 0}
                  leakCount={target.get('leakAllcount')}
                  leakSize={common.fileSizeTrans(target.get('leakAllsize')).common}
                  size={'s'}
                />
                <LeakCountInfo
                  formatMessage={formatMessage}
                  type="all"
                  count={target.get('leakAllcount')}
                  size={target.get('leakAllsize')}
                />
              </div>
            </div>
          </div>

          {/* 감염대상 상세 */}
          {infectionTarget.get('isOpen').indexOf(target.get('targetNo')) !== -1 && (
            <div className={cx('infection-detail')}>
              <div className={cx('detailInner-area')}>
                <div className={cx('bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetailTag_25', defaultMessage: '대상자 정보' }))}
                </div>
                <div className={cx('detailContent-area')}>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_26', defaultMessage: '번호' }))}
                    </div>
                    <div className={cx('detail-content')}>{target.get('targetNo')}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_27', defaultMessage: '이름' }))}
                    </div>
                    <div className={cx('detail-content')}>{target.get('targetName')}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_28', defaultMessage: '메일' }))}
                    </div>
                    <div className={cx('detail-content')}>{target.get('targetEmail')}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_29', defaultMessage: '소속' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {target.get('targetDivision') ? target.get('targetDivision') : '-'}
                    </div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_30', defaultMessage: '직급' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {target.get('targetPosition') ? target.get('targetPosition') : '-'}
                    </div>
                  </div>
                </div>
              </div>
              <div className={cx('detailInner-area mt-10')}>
                <div className={cx('bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetailTag_31', defaultMessage: '일시' }))}
                </div>
                <div className={cx('detailContent-area')}>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_32', defaultMessage: '메일 발송' }))}
                    </div>
                    <div className={cx('detail-content')}>{common.timeFormatFromUTCEpoch(target.get('sendEpoch'))}</div>
                  </div>
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_33', defaultMessage: '메일 확인' }))}
                    </div>
                    <div className={cx('detail-content')}>{common.timeFormatFromUTCEpoch(target.get('readEpoch'))}</div>
                  </div>
                  {(2 & target.get('linkAttach') || 4 === target.get('examType')) && (
                    <div className={cx('targetExam-item')}>
                      <div className={cx('detail-title')}>
                        {defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      </div>
                      <div className={cx('detail-content')}>
                        {common.timeFormatFromUTCEpoch(target.get('downloadEpoch'))}
                      </div>
                    </div>
                  )}
                  <div className={cx('targetExam-item')}>
                    <div className={cx('detail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_34', defaultMessage: '감염 파일 실행' }))}
                    </div>
                    <div className={cx('detail-content')}>
                      {common.timeFormatFromUTCEpoch(target.get('infectionEpoch'))}
                    </div>
                  </div>
                  {1 === target.get('examType') &&
                    2 === attachExamType && (
                      <div className={cx('targetExam-item')}>
                        <div className={cx('detail-title')}>
                          {defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' }))}
                        </div>
                        <div className={cx('detail-content')}>
                          {common.timeFormatFromUTCEpoch(target.get('cureEpoch'))}
                        </div>
                      </div>
                    )}
                </div>
              </div>
              {target.get('infectionPc') && (
                <div className={cx('detailInner-area mt-10')}>
                  <div className={cx('bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_35', defaultMessage: '감염 정보' }))}
                  </div>
                  <div className={cx('infection-info')}>
                    <InfectionPC
                      pcCount={target.get('infectionPc').size}
                      leakCount={target.get('leakAllcount')}
                      leakSize={common.fileSizeTrans(target.get('leakAllsize')).common}
                      size={'s'}
                      noTooltip
                    />
                    <div className={cx('count-area')}>
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="all"
                        count={target.get('leakAllcount')}
                        size={target.get('leakAllsize')}
                      />
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="file"
                        count={target.get('leakFileCount')}
                        size={target.get('leakFileSize')}
                      />
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="cert"
                        count={target.get('leakCertCount')}
                        size={target.get('leakCertSize')}
                      />
                      <LeakCountInfo
                        formatMessage={formatMessage}
                        type="mail"
                        count={target.get('leakEmailCount')}
                        size={target.get('leakEmailSize')}
                      />
                    </div>
                  </div>
                </div>
              )}
              {target.get('infectionPc') && (
                <div className={cx('detailInner-area', 'mt-10')}>
                  <div className={cx('bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_36', defaultMessage: '감염 PC 목록' }))}
                  </div>
                  <div className={cx('infectionPc-content')}>
                    {target.get('infectionPc').map((pcData, index) => (
                      <div key={index} className={cx('infectionPc-item')}>
                        <div
                          className={cx('pc-info', 'ellipsis')}
                          title={pcData.get('hostname') + ' (' + pcData.get('ip') + ')'}>
                          <span className={cx('bold mr-5')}>·</span>
                          <span>{pcData.get('hostname') + ' (' + pcData.get('ip') + ')'}</span>
                        </div>
                        <div className={cx('date-info')}>
                          <span>
                            {defineMessages(formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' }))}
                          </span>
                          <span className={cx('date-text')}>
                            {common.timeFormatFromUTCEpoch(pcData.get('regEpoch'), 1)}
                          </span>
                        </div>
                        <div className={cx('count-area')}>
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="all"
                            count={pcData.get('leakAllcount')}
                            size={pcData.get('leakAllsize')}
                          />
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="file"
                            count={pcData.get('leakFileCount')}
                            size={pcData.get('leakFileSize')}
                          />
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="cert"
                            count={pcData.get('leakCertCount')}
                            size={pcData.get('leakCertSize')}
                          />
                          <LeakCountInfo
                            formatMessage={formatMessage}
                            type="mail"
                            count={pcData.get('leakEmailCount')}
                            size={pcData.get('leakEmailSize')}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ));
    }

    // 감염 PC 리스트
    let InfectionPcComponent = (
      <div className={cx('brand')}>
        <Icon name="checkmark box" />
        {defineMessages(formatMessage({ id: 'ExamDetailTag_37', defaultMessage: '감염 PC 없음' }))}
      </div>
    );

    if (
      !isPhishing &&
      infectionPC.get('data') &&
      infectionPC.get('data').size > 0 &&
      infectionPC.getIn(['data', 0, 'hostname'])
    ) {
      InfectionPcComponent = infectionPC.get('data').map((pc, index) => (
        <div key={index} className={cx('infectionPc-set')}>
          <div className={cx('pc-info-area ellipsis')}>
            <div className={cx('pc-info', 'ellipsis')} title={pc.get('hostname') + ' (' + pc.get('ip') + ')'}>
              <span className={cx('bold mr-5')}>·</span>
              <span className={cx('pc')}>{pc.get('hostname')}</span>
              <span className={cx('ip')}>{' (' + pc.get('ip') + ')'}</span>
            </div>
            <div className={cx('date-info')}>
              <span>{defineMessages(formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' }))}</span>
              <span className={cx('date-text')}>{common.timeFormatFromUTCEpoch(pc.get('regEpoch'), 1)}</span>
            </div>
            <div
              className={cx('date-info', 'ellipsis')}
              title={pc.get('targetName') + ' (' + pc.get('targetEmail') + ')'}>
              <span className={cx('target')}>{pc.get('targetName')}</span>
              <span className={cx('mail')}>{' (' + pc.get('targetEmail') + ')'}</span>
            </div>
          </div>
          <div className={cx('count-area')}>
            <LeakCountInfo
              formatMessage={formatMessage}
              type="all"
              count={pc.get('leakAllcount')}
              size={pc.get('leakAllsize')}
            />
            <LeakCountInfo
              formatMessage={formatMessage}
              type="file"
              count={pc.get('leakFileCount')}
              size={pc.get('leakFileSize')}
            />
            <LeakCountInfo
              formatMessage={formatMessage}
              type="cert"
              count={pc.get('leakCertCount')}
              size={pc.get('leakCertCount')}
            />
            <LeakCountInfo
              formatMessage={formatMessage}
              type="mail"
              count={pc.get('leakEmailCount')}
              size={pc.get('leakEmailSize')}
            />
          </div>
        </div>
      ));
    }
    return (
      <DetailTemplate btDatas={btDatas} onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper')}>
            {/* ----------------------------------------- 훈련 정보 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-info')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-info', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_1', defaultMessage: '태그별 훈련 결과' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_38', defaultMessage: '태그 번호' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {!!detailData.get('tagNo') ? detailData.get('tagNo') : '-'}
                    </span>
                  </div>
                  <div className={cx('examInfo', 'examInfo-tag')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_39', defaultMessage: '태그명' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      <TagItem
                        tagItem={Map({
                          tagNo: detailData.get('tagNo'),
                          tagName: detailData.get('tagName'),
                          color: detailData.get('color'),
                          tagInitial: detailData.get('tagInitial')
                        })}
                        className={cx('targetItem-tagItem')}
                        size="small"
                      />
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_40', defaultMessage: '훈련 번호' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('examNo')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_41', defaultMessage: '훈련명' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('examName')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_42', defaultMessage: '훈련 대상' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('target') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      {detailData.get('examTargetRandomPer') < 100
                        ? ' (' +
                          defineMessages(
                            formatMessage({ id: 'StartExam_11', defaultMessage: '훈련 대상자 선택 비율' })
                          ) +
                          ' ' +
                          detailData.get('examTargetRandomPer') +
                          '%)'
                        : ''}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_43', defaultMessage: '발송' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('isSuspend') === 1 &&
                        '(' +
                          defineMessages(
                            formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })
                          ) +
                          ') '}
                      {detailData.get('send') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      {detailData.get('send') + detailData.get('sendError') < detailData.get('target') &&
                        ' (' +
                          defineMessages(formatMessage({ id: 'ExamHeader_21', defaultMessage: '진행중' })) +
                          ': ' +
                          (
                            (detailData.get('send') + detailData.get('sendError')) /
                            detailData.get('target') *
                            100
                          ).toFixed(0) +
                          '%)'}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailTag_44', defaultMessage: '열람' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('read') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                    </span>
                  </div>
                  {typeof detailData.get('download') !== 'undefined' && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {isPhishing
                          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                          : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('download') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {isPhishing
                        ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
                        : defineMessages(formatMessage({ id: 'ExamDetailTag_45', defaultMessage: '감염' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('infection') +
                        ' ' +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                    </span>
                  </div>
                  {!isPhishing && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'ExamSearch_5', defaultMessage: '감염 PC' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('infectionPc') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_17', defaultMessage: '대' }))}
                      </span>
                    </div>
                  )}
                  {!isPhishing &&
                    1 === detailData.get('examType') &&
                    2 === attachExamType &&
                    typeof detailData.get('cure') !== 'undefined' && (
                      <div className={cx('examInfo')}>
                        <span className={cx('examInfo-title')}>
                          {defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' }))}
                        </span>
                        <span className={cx('examInfo-content')}>
                          {detailData.get('cure') +
                            ' ' +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </span>
                      </div>
                    )}
                  {/* 신고 하기 */}
                  {commonVar.isDeclare === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('declare') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                  {/* 교육 하기 */}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_20', defaultMessage: '연결된 교육' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduByTag') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_21', defaultMessage: '교육 대상자' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduTarget') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 태그 대상자 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-tagTargetList')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-tagTargetList', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_2', defaultMessage: '태그 대상자 목록' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingTargetByTag && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {/* 대상자 목록 */}
                  {TagTargetList}
                  {targetListByTag.get('totalPage') > 1 &&
                    targetListByTag.get('totalPage') > targetListByTag.get('page') && (
                      <div className={cx('bt-addView')} onClick={() => onGetTargetListByTag()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'ExamDetailTag_47', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 감염 가능 파일 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-infectionFile')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-infectionFile', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_3', defaultMessage: '감염 가능 파일' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>{InfectionFile}</div>
              </div>
            )}
            {/* ----------------------------------------- 감염 대상 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-target')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-target', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_4', defaultMessage: '감염 대상' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingTarget && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {InfectionTargetComponent}
                  {infectionTarget.get('totalPage') > 1 &&
                    infectionTarget.get('totalPage') > infectionTarget.get('page') && (
                      <div className={cx('bt-addView')} onClick={() => onGetInfectionFile()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'ExamDetailTag_47', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 감염 PC ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-pc')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-pc', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailTag_5', defaultMessage: '감염 PC' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  {isLoadingPC && (
                    <div className={cx('Loading')}>
                      <Loading content={'Loading...'} />
                    </div>
                  )}
                  {InfectionPcComponent}
                  {infectionPC.get('totalPage') > 1 &&
                    infectionPC.get('totalPage') > infectionPC.get('page') && (
                      <div className={cx('bt-addView')} onClick={() => onGetInfectionPC()}>
                        <Icon name="plus circle" />
                        {defineMessages(formatMessage({ id: 'ExamDetailTag_47', defaultMessage: '더보기' }))}
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

export default injectIntl(ExamDetailTag);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamDetailTag.js